
import { getStoredQuotes, quoteToMemory } from './quotes';
import { getStoredMilestones, milestoneToMemory } from './milestones';
import { Memory } from '@/types/memory';
import { logger } from '@/utils/logger';

// Get all memories (combined quotes and milestones)
export const getAllMemories = async (): Promise<Memory[]> => {
  try {
    const quotes = await getStoredQuotes();
    const milestones = await getStoredMilestones();

    const allMemories = [
      ...quotes.map(quoteToMemory),
      ...milestones.map(milestoneToMemory)
    ];

    // Sort all memories chronologically by date (newest first by default)
    return allMemories.sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return dateB - dateA; // newest first
    });
  } catch (error) {
    logger.error('Error in getAllMemories:', error);
    return [];
  }
};
